if (!customElements.get("color-swatch")) {
  customElements.define(
    "color-swatch",
    class ColorSwatch extends HTMLElement {
      constructor() {
        super();
        this.cardContainer = this.querySelector(".card__container");
        this.productWrapper = this.cardContainer.querySelector(".product-color-swatch-wrapper");
        this.swatchButtons = this.productWrapper?.querySelectorAll('.product-color-swatch');
        this.plusButton = this.productWrapper?.querySelector('.plus-button');
        this.plusText = this.plusButton?.querySelector('.plus-text');
        this.minusText = this.plusButton?.querySelector('.minus-text');
        this.quickAddButton = this.querySelector(".custom-quick-add");
        this.sizeSelectorCloseButton = this.querySelector(".size-selector-close");
        // this.sizeInputButtons = this.querySelectorAll(".size-input-btn");
      }

      connectedCallback() {
        this.initialize();
        this.attachSwatchEvents();
        this.quickAddClick();
        this.sizeSelectorCloseHandler();
        this.quickAddToCart();
        //  Attach document click listener
        this._outsideClickListener = this._handleOutsideClick.bind(this);
        document.addEventListener("click", this._outsideClickListener, true);
      }

      _handleOutsideClick(event) {
        const isInsideComponent = this.contains(event.target);
        const isInsideSizeSelector = event.target.closest(".size-selector-wrapper");
        if (!isInsideComponent && !isInsideSizeSelector) {
          this.updateSizeDisplayWhenClickOutside();
        }
      }

      updateSizeDisplayWhenClickOutside() {
        document.querySelectorAll(".size-selector-wrapper").forEach((element) => {
          element?.classList.add('hidden');
        });

        document.querySelectorAll(".custom-quick-add").forEach((element) => {
          element?.classList.remove('hidden');
        });
      }

      quickAddClick() {
        const quickAddButton = this.querySelector('.custom-quick-add');
        const sizeSelectorWrapper = this.querySelector('.size-selector-wrapper');
        if (quickAddButton) {
          quickAddButton.addEventListener('click', (e) => {
            e.preventDefault();
            sizeSelectorWrapper?.classList.remove('hidden');
            quickAddButton?.classList.add('hidden');
          });
        }
      }

      sizeSelectorCloseHandler() {
        const sizeSelectorCloseButton = this.querySelector('.size-selector-wrapper .close-button');
        const sizeSelectorWrapper = this.querySelector('.size-selector-wrapper');
        const customQuickAdd = this.querySelector('.custom-quick-add');

        if (sizeSelectorCloseButton) {
          sizeSelectorCloseButton.addEventListener('click', (e) => {
            e.preventDefault();
            sizeSelectorWrapper?.classList.add('hidden');
            customQuickAdd?.classList.remove('hidden');
          });
        }
      }

   /* CT fix (2026-07-20): double-add guard. The old version bound a
      listener per chip and re-bound after every swatch re-render — if
      the re-render fetch returned unexpected markup the old chips
      survived with TWO listeners, and the chip also stayed tappable
      while an add was in flight (slow networks → tap-tap → two adds).
      Now: ONE delegated listener on the component (survives innerHTML
      swaps, can never stack thanks to the bound flag) and an
      in-flight flag per chip. The chip button itself is type=button
      with no name=add (see the snippet) so third-party checkout
      scripts that hook button[name=add] no longer fire their own
      parallel add. Loader toggles are null-safe so a markup change
      can never strand the chip in a loading state. */
   quickAddToCart() {
  if (this._ctQuickAddBound) return;
  this._ctQuickAddBound = true;

  this.addEventListener('click', async (e) => {
    const button = e.target && e.target.closest ? e.target.closest('.size-input-btn') : null;
    if (!button || !this.contains(button)) return;
    e.preventDefault();

    if (button.dataset.ctAdding === '1') return;

    const form = button.closest('form');
    const variantInput = form ? form.querySelector('input[name="id"]') : null;
    const variantId = variantInput ? variantInput.value : null;

    if (!variantId) {
      console.error('Variant ID not found');
      return;
    }

    const vLoader = button.querySelector('.variant-loader');
    const vTitle = button.querySelector('.variant-title');
    const setLoading = (on) => {
      if (vLoader) vLoader.classList.toggle('hidden', !on);
      if (vTitle) vTitle.classList.toggle('hidden', on);
    };
    button.dataset.ctAdding = '1';
    setLoading(true);

    const itemsToAdd = [
      {
        id: variantId,
        quantity: 1,
      }
    ];

    let formData = {
      items: itemsToAdd,
    };

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (res.ok) {
        const data = await res.json();

        document.body.classList.remove('overflow-hidden');

        setLoading(false);

      } else {
        const err = await res.json();
        alert(err.description || 'Something went wrong');

        setLoading(false);
      }

    } catch (error) {
      console.error('Fetch error:', error);
      alert('Network error. Please try again.');

      setLoading(false);
    } finally {
      delete button.dataset.ctAdding;
    }
  });
}

      attachSwatchEvents() {
        this.productWrapper = this.querySelector(".product-color-swatch-wrapper");
        this.swatchButtons = this.productWrapper?.querySelectorAll('.product-color-swatch');
        this.plusButton = this.productWrapper?.querySelector('.plus-button');
        this.plusText = this.plusButton?.querySelector('.plus-text');
        this.minusText = this.plusButton?.querySelector('.minus-text');

        if (this.plusButton) {
          this.plusButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.toggleDisplayOfSwatches();
          });
        }

        if (this.swatchButtons) {
          this.swatchButtons.forEach((swatch) => {
            swatch.addEventListener('click', () => {
              this.swatchButtons.forEach((swatch) => swatch.classList.remove("active"));
              this.renderProductDetails(swatch);
            });
          });
        }
      }

      initialize() {
        this.initProperites();
        this.initButtons();
        this.initCounter();
        this.updateSwatchDisplay(false);
      }

      toggleDisplayOfSwatches() {
        this.productWrapper.classList.toggle("is-open");
        this.swatchButtons.forEach((swatch) => {
          const swatchWrapper = swatch.closest('.swatch-wrapper');

          const index = parseInt(swatch.dataset.index, 10);
          if (index >= 5) {
            if (swatch.classList.contains('hidden')) {
              swatch.classList.remove('hidden');
              if (swatchWrapper) {
                swatchWrapper.classList.remove('hidden');
              }
            } else {
              swatch.classList.add('hidden');
              if (swatchWrapper) {
                swatchWrapper.classList.add('hidden');
              }
            }
          }
        });

        this.plusText.classList.toggle('hidden');
        this.minusText.classList.toggle('hidden');
      }

      async renderProductDetails(swatch) {
        let currentVariantHandle = swatch.dataset.currentVariantHandle;
        let currentVariantId = swatch.dataset.currentVariantId;
        let url = `/products/${currentVariantHandle}?variant=${currentVariantId}&sections=product-card`;
        try {
          const response = await fetch(url);
          const responseJson = await response.json();
          const rawHTML = responseJson["product-card"];
          const decodedHTML = rawHTML
            .replace(/&quot;/g, '"') // Replace &quot; with "
            .replace(/\\n/g, "") // Remove \n
            .replace(/\\&quot;/g, '"') // Handle escaped quotes within backslashes
            .replace(/&#39;/g, "'");
          const html = new DOMParser().parseFromString(decodedHTML, "text/html");
          const updatedProductCard = html.querySelector('.card__container');
          const oldProductCard = this.querySelector(".card__container");
          const wasSwatchOpen = document
            .querySelector(".product-color-swatch-wrapper")
            ?.classList.contains("is-open");

          if (oldProductCard && updatedProductCard) {
            oldProductCard.innerHTML = updatedProductCard.innerHTML;
            if (wasSwatchOpen) {
              const swatchWrapper = oldProductCard.querySelector(".product-color-swatch-wrapper");
              swatchWrapper?.classList.add("is-open");
              oldProductCard.querySelector(".plus-text")?.classList.add("hidden");
              oldProductCard.querySelector(".minus-text")?.classList.remove("hidden");
            }
          }
          this.attachSwatchEvents();
          this.updateSwatchDisplay(wasSwatchOpen);
          this.quickAddClick();
          this.sizeSelectorCloseHandler();
          this.quickAddToCart();
          document.addEventListener("click", this._outsideClickListener, true);
        } catch (error) {
          console.error("Error fetching product info:", error);
        }
      }

      updateSwatchDisplay(isswatchWrapperOpen) {
        if (!isswatchWrapperOpen) {
          if (this.swatchButtons) {

            this.swatchButtons.forEach((swatch) => {
              const swatchWrapper = swatch.closest('.swatch-wrapper');

              const index = parseInt(swatch.dataset.index, 10);
              if (index >= 5 && !swatch.classList.contains('hidden')) {
                swatch.classList.add('hidden');
                if (swatchWrapper) swatchWrapper.classList.add('hidden');
              }

              if (swatch.dataset.currentVariantId == swatch.dataset.productId) {
                swatch.classList.add('active');
                if (swatchWrapper) swatchWrapper.classList.add('active');
              }
            });
          }
        }
      }

      initProperites() {
        const node = this;
        this.container = node.querySelector(".card__container");
        this.adnotation = node.querySelector(".card");
        this.color_swatcher_container = this.container.querySelector(
          ".card__color-swatcher--container",
        );
        this.color_swatcher_wrappers = this.container.querySelectorAll(
          ".color-swatcher--wrapper",
        );
        this.color_swatcher_counter = this.container.querySelector(
          ".color-swatcher--counter",
        );
        [this.img, this.hover_img] =
          this.container.querySelectorAll(".card__img");
        this.video = this.querySelector("video");
        this.clicked_href = this.adnotation.getAttribute("href");
        this.clicked_img = this.img?.getAttribute("src");
        this.clicked_srcset = this.img?.getAttribute("srcset");
        this.clicked_hover_img = this.hover_img?.getAttribute("src");

        this.loader = this.querySelector(".card__loader");

        this.optionsAsColorSwatches = this.color_swatcher_container?.dataset.optionsAsColorSwatches?.split(",") || [];
      }

      initCounter() {
        if (this.color_swatcher_wrappers?.length > 4) {
          this.color_swatcher_counter.innerHTML += `+ ${this.color_swatcher_wrappers.length - 4}`;
          this.color_swatcher_container.addEventListener("mouseover", () =>
            this.showAllWrappers(),
          );
        }
      }

      showAllWrappers() {
        this.color_swatcher_wrappers.forEach((wrapper) =>
          wrapper.classList.remove("hidden"),
        );
        this.color_swatcher_counter.classList.add("hidden");
      }

      initButtons() {
        this.activeFilters = null;

        try {
          this.activeFilters = activeFilters;
        } catch (err) { }


        this.isCheckedOption = 0;
        this.isCheckedActiveFilter = false;

        if (this.color_swatcher_wrappers) {
          this.sortButtons();
          this.color_swatcher_wrappers.forEach((wrapper, index) => {
            const button = wrapper.querySelector(".color-swatcher");
            const attributes = this.getButtonAttributes(button);
            const tooltip = wrapper.querySelector(".color-swatcher--tooltip");

            if (this.isCheckedOption === 0)
              this.checkFilterOption(wrapper, attributes);

            if (index > 3) {
              wrapper.classList.add("hidden");
            }

            // find filter color and preselect it 
            if (this.activeFilters && !this.isCheckedActiveFilter) {
              const colorName = attributes.dataColor;
              for (const option of this.optionsAsColorSwatches) {
                const options = this.activeFilters[option];
                if (options && options[colorName]) {
                  this.handleClickEvent(wrapper, attributes)
                  this.isCheckedActiveFilter = true;
                  break;
                }
              }
            }

            this.assignWrapperEvents(wrapper, attributes, tooltip);
          });
        }

        if (this.color_swatcher_container) {
          this.color_swatcher_container.addEventListener("mouseleave", () =>
            this.restoreAttributes(),
          );
        }
      }

      getButtonAttributes(button) {
        return {
          dataColor: button.getAttribute("data-color"),
          button_href: button.getAttribute("data-href"),
          button_img: button.getAttribute("data-img"),
          button_srcset: button.getAttribute("data-srcset"),
          button_hover: button.getAttribute("data-hover"),
        };
      }

      checkFilterOption(
        wrapper,
        { dataColor, button_href, button_img, button_hover, button_srcset },
      ) {
        const filtersArray = Object.entries(activeOptions);

        if (this.isCheckedOption === 0) {
          for (const [key, value] of filtersArray) {
            if (value.indexOf(dataColor) !== -1) {
              this.setAttributes(this.adnotation, { href: button_href });
              this.setAttributes(this.img, { src: button_img });
              this.checkHoverImage(button_hover);
              this.clicked_href = button_href;
              this.clicked_img = button_img;
              this.clicked_srcset = button_srcset;
              this.clicked_hover_img = button_hover;
              wrapper.classList.add("active");
              this.isCheckedOption = 1;
              break;
            }
          }
        }
      }

      assignWrapperEvents(wrapper, attributes, tooltip) {
        wrapper.addEventListener("click", () =>
          this.handleClickEvent(wrapper, attributes),
        );
        wrapper.addEventListener("keydown", (e) => {
          if (e.key === "Enter") {
            this.handleClickEvent(wrapper, attributes);
          }
        });
        wrapper.addEventListener("mouseover", () =>
          this.handleMouseOverEvent(wrapper, attributes, tooltip),
        );
        wrapper.addEventListener("mouseout", () =>
          this.handleMouseOutEvent(tooltip),
        );
      }

      handleClickEvent(
        wrapper,
        { button_href, button_img, button_hover, button_srcset },
      ) {
        if (!button_img) return

        this.showLoader();

        this.setAttributes(this.adnotation, { href: button_href });
        this.setAttributes(this.img, { src: button_img });
        this.setAttributes(this.img, { srcset: button_srcset });
        this.checkHoverImage(button_hover);
        this.color_swatcher_wrappers.forEach((wrap) => {
          wrap.classList.remove("active");
        });
        this.clicked_href = button_href;
        this.clicked_img = button_img;
        this.clicked_srcset = button_srcset;
        this.clicked_hover_img = button_hover;
        wrapper.classList.add("active");

        this.video?.classList.add("hidden");
        this.isVideoHidden = true;
        this.img.classList.remove("hidden");
        this.img.onload = () => {
          this.hideLoader();
          this.img.onload = null;
        };
      }

      showLoader() {
        this.loader.classList.remove("hidden");
        this.loader.innerHTML = '<div class="spinner-ring"></div>';
        if (!this.img) return;
        this.img.style.opacity = 0;
      }

      hideLoader() {
        this.loader.classList.add("hidden");
        this.loader.innerHTML = "";
        if (!this.img) return;
        this.img.style.opacity = 1;
      }

      handleMouseOverEvent(
        wrapper,
        { button_href, button_img, button_hover, button_srcset },
        tooltip,
      ) {
        this.setAttributes(this.adnotation, { href: button_href });
        this.setAttributes(this.img, { src: button_img });
        this.setAttributes(this.img, { srcset: button_srcset });
        this.checkHoverImage(button_hover);
        tooltip.classList.remove("hidden");
        this.setTooltipPosition(tooltip);
      }

      handleMouseOutEvent(tooltip) {
        tooltip.classList.add("hidden");
        tooltip.classList.remove(
          "color-swatcher--tooltip-left",
          "color-swatcher--tooltip-right",
        );
      }

      setTooltipPosition(tooltip) {
        const coords = tooltip.getBoundingClientRect();
        const screenWidth = window.innerWidth;

        if (!coords) return;

        if (coords.x < 0) {
          tooltip.classList.add("color-swatcher--tooltip-left");
        } else if (coords.right > screenWidth) {
          tooltip.classList.add("color-swatcher--tooltip-right");
        }
      }

      setFirstOptionActive() {
        const wrapper = this.color_swatcher_wrappers[0];
        if (wrapper) {
          const button = wrapper.querySelector(".color-swatcher");
          const attributes = this.getButtonAttributes(button);
          this.setAttributes(this.adnotation, { href: attributes.button_href });
          this.setAttributes(this.img, { src: attributes.button_img });
          this.setAttributes(this.img, { srcset: attributes.button_srcset });
          this.checkHoverImage(attributes.button_hover);
          wrapper.classList.add("active");
        }
      }

      restoreAttributes() {
        this.setAttributes(this.adnotation, { href: this.clicked_href });
        this.setAttributes(this.img, { src: this.clicked_img });
        this.setAttributes(this.img, { srcset: this.clicked_srcset });
        this.checkHoverImage(this.clicked_hover_img);
      }

      sortButtons() {
        if (this.color_swatcher_wrappers) {
          const newArr = Array.from(this.color_swatcher_wrappers).sort(
            (a, b) => {
              const classA = a.classList?.contains("unavailable");
              const classB = b.classList?.contains("unavailable");
              return classA && !classB ? 1 : !classA && classB ? -1 : 0;
            },
          );

          if (this.color_swatcher_container) {
            this.color_swatcher_container.innerHTML = "";
          }

          newArr.forEach((el) => this.color_swatcher_container.append(el));
          this.createCounterSpan();
          this.color_swatcher_wrappers = this.container.querySelectorAll(
            ".color-swatcher--wrapper",
          );
          this.color_swatcher_counter = this.container.querySelector(
            ".color-swatcher--counter",
          );
        }
      }

      createCounterSpan() {
        const counter_span = document.createElement("span");
        counter_span.classList.add("color-swatcher--counter");
        this.color_swatcher_container?.appendChild(counter_span);
      }

      setAttributes(element, attrs) {
        for (let key in attrs) {
          element?.setAttribute(key, attrs[key]);
        }
      }

      checkHoverImage(button_hover) {
        if (button_hover && this.hover_img) {
          this.setAttributes(this.hover_img, { src: button_hover });
        }
      }
    },
  );
}
